export enum ChicletTypes {
  'Completed' = 'Completed',
  'In_progress' = 'In progress',
  'Overdue' = 'Overdue',
  'Not_started' = 'Not started',
  'Recommended' = 'Recommended'
}